// Production Auth0 client. There is no separate dev
// client — local dev uses the bypass mechanism instead (see devBypass.ts).
// Values can be overridden at build time via Vite env vars (VITE_AUTH0_*).
// Uses `||` (not `??`) so an empty-string env var falls back to the default
// rather than silently shipping with broken Auth0 config.
export const AUTH0_DOMAIN = import.meta.env.VITE_AUTH0_DOMAIN || 'login.n3o.cloud'
export const AUTH0_CLIENT_ID =
  import.meta.env.VITE_AUTH0_CLIENT_ID || '8ipxKMyFeeDtW9Ng9CVH0oJw7d27jf3A'
export const AUTH0_AUDIENCE =
  import.meta.env.VITE_AUTH0_AUDIENCE || 'https://n3o.ltd/karakoram'
export const AUTH0_SCOPE = 'openid profile email offline_access'

export const N3O_APP_ID = 'link-builder'
